import { ASTRAFLOW_ASTRA_MODELS } from '../../constants/astraflowAstraModels.js';

// 仅用于界面分组；选择值仍是具体模型 ID，不能用大类替代厂商路由。
export const IMAGE_MODEL_FAMILIES = [
  {
    id: 'chatgpt',
    label: 'ChatGPT',
    modelIds: [
      'wangsugpt', 'gptimage', 'huobao_gpt_image_cheap',
      'astraflow_openai', 'astraflow_openai_luna', 'astraflow_openai_terra', 'astraflow_openai_sol',
      ...ASTRAFLOW_ASTRA_MODELS.map(({ id }) => id),
      'astraflow_image_flare', 'astraflow_image_sunburst',
      'datastart_sunburst', 'datastart_flare',
      'omini_openai', 'newapi_image', 'dreamfly_gpt_image_2',
    ],
  },
  {
    id: 'gemini',
    label: 'Gemini',
    modelIds: [
      'wangsugem', 'astraflow_gemini', 'omini',
      'dreamfly_gemini_3_pro_image_preview', 'dreamfly_gemini_3_1_flash_image',
    ],
  },
  { id: 'wanx', label: '万相', modelIds: ['wanx'] },
  { id: 'midjourney', label: 'MidJourney', modelIds: ['claude_opus_mj'] },
  { id: 'other', label: '其他', modelIds: ['doubao', 'astraflow_grok'] },
];
